"use strict";
// tabObjMaps contains all title index with main relations 
var tabObjMaps = [];
window.tab = {
    titles: null,
    contents: null,
    init: function () {
        var currentHash = window.location.hash;
        // Collect all the tabs and their contents
        window.tabs = document.querySelectorAll('.tabs');
        window.allContent = document.querySelectorAll('.tabs ~ .tabs-content');
        // Initialize the indexes
        var titleIndex = 0;
        var activeTitleIndex = 0;
        var titleSetByHash = false;
        // If no tabs are defined then stop the unnecessary processing
        // Or if the tabs # and contents # are mismatching (every tabs should have one content)
        if (window.tabs.length === 0 || window.tabs.length !== window.allContent.length) {
            return;
        }
        // Iterate through the tabs to add tabindexes and event listeners
        for (var i = 0; i < window.tabs.length; i++) {
            // Get the tabs' title and content element
            window.tab.titles = window.tabs[i].querySelectorAll('.tab-title');
            window.tab.contents = findAll(window.allContent[i], '.content');
            // Stop if there are no title/contents or if their # are mismatching
            if (window.tab.titles.length == 0 || window.tab.contents.length == 0 || window.tab.titles.length !== window.tab.contents.length) {
                continue;
            }
            // Iterate through all the titles
            for (var j = 0; j < window.tab.titles.length; j++) {
                var titleHref = window.tab.titles[j].querySelector('li > a').getAttribute("href");
                var tabObj = {};
                // Add the tabindex and setting the onclick listener that handles the tab activation process
                window.tab.titles[j].tabIndex = titleIndex;
                window.tab.contents[j].setAttribute("tabindex", titleIndex);
                window.tab.titles[j].addEventListener("click", window.tabSwitch, true);
                // Initialize the helper array with relations
                tabObj['tabIndex'] = i;
                tabObj['parentTitleIndex'] = getParentContentIndex(window.tab.titles[j]);
                tabObj['childTabIndex'] = setChildTabIndex(getParentContentIndex(window.tab.titles[j]), i);
                // Add it to the global helper object
                tabObjMaps.push(tabObj);
                // Check if the hash from the url is matching the hash attribute of the current title
                // if yes then it will be the active tab instead of the default first
                if (currentHash === titleHref) {
                    activeTitleIndex = titleIndex;
                    titleSetByHash = true;
                }
                // Check if the title has active class
                if (window.tab.titles[j].classList.contains('active')) {
                    // Deactive the title for now, so it's only activated if it has the highest priority
                    setTabToInactive(window.tab.titles[j]);
                    // Flag the title to be active only if the activeTitle is not already determined by hash
                    if (!titleSetByHash) {
                        activeTitleIndex = titleIndex;
                    }
                }
                titleIndex++;
            }
            // Activate the first tab by default
            setTabToActive(window.tab.titles[0], false, false);
        }
        // Get info of the active tab from the helper object
        var tabIndex = tabObjMaps[activeTitleIndex].tabIndex;
        var activeTitle = getTitle(tabIndex, activeTitleIndex);
        // Deactivate the default active tab
        if (activeTitleIndex != 0) {
            var firstTitle = getFirstTitle(tabIndex);
            setTabToInactive(firstTitle);
        }
        // Activate the active tab and everything above so it's visible
        setTabToActive(activeTitle, true, false);
    },
};
// Run tab init when the document has loaded
document.addEventListener("DOMContentLoaded", function (event) {
    window.tab.init();
});
/**
 * Clicking on the title element when the url hash changes
 *
 */
function hashHandler() {
    var element = document.querySelector('.tab-title a[href="' + window.location.hash + '"]');
    if (element !== null) {
        // Making a click on the element with the hash
        element.click();
    }
}
// Add a hashchange eventlistener
window.addEventListener('hashchange', hashHandler, false);
/**
 * Activate the event target's tab and deactivates the previous active tab
 *
 * @param {Object} event
 */
window.tabSwitch = function (event) {
    event.preventDefault();
    var target = event.currentTarget, targetParent = target.parentElement, activeTitle = targetParent.querySelector(".active");
    // Only proceed if IE restricting is not in place
    if (typeof window.IS_IE !== typeof undefined && window.IS_IE && target.classList.contains(window.RESTRICT_IE_CLASS)) {
        return true;
    }
    setTabToInactive(activeTitle);
    setTabToActive(target, true);
};
/**
 * Activate a title and it's content
 *
 * @param {Object} title
 * @param {bool} withParent
 * @param {bool} needHrefUpdate
 */
function setTabToActive(title, withParent, needHrefUpdate) {
    needHrefUpdate = typeof needHrefUpdate !== 'undefined' ? needHrefUpdate : true;
    var tabIndex = getTitleIndex(title);
    var content = getContentByTitle(title);
    // Activating the title
    title.classList.add("active");
    // Activate it's content
    content.classList.add("active");
    content.setAttribute("aria-hidden", false);
    // Activate the title's parent if necessary
    if (tabObjMaps[tabIndex] !== 'undefined' && withParent) {
        var parentTitleIndex = tabObjMaps[tabIndex].parentTitleIndex;
        var childTabIndex = tabObjMaps[tabIndex].childTabIndex;
        // If found activate it
        if (parentTitleIndex) {
            var parentTabIndex = tabObjMaps[parentTitleIndex].tabIndex;
            var parentTitle = getTitle(parentTabIndex, parentTitleIndex);
            var activeParentTitle = getActiveTitle(parentTabIndex);
            // Needs this condition because when tabSwitch triggered by hashHandler() then possible two active title in same tab
            // NOTE not sure if this is needed anymore
            if (activeParentTitle !== null) {
                setTabToInactive(activeParentTitle);
            }
            setTabToActive(parentTitle, true);
        }
        // Activate title's childs
        if (childTabIndex) {
            if (window.tabs[childTabIndex].querySelectorAll('.tab-title.active, .active.accordion-navigation').length === 0) {
                var childTitle = window.tabs[childTabIndex].querySelectorAll('.tab-title, .accordion-navigation')[0];
                setTabToActive(childTitle, true);
            }
        }
    }
    if (needHrefUpdate) {
        var currentTitleHref = title.querySelector('li > a').getAttribute("href");
        setHref(currentTitleHref);
    }
}
/**
 * Deactivate title and content
 *
 * @param {Object} title
 */
function setTabToInactive(title) {
    // Get it's content
    var content = getContentByTitle(title);
    // Deactivate the title
    title.classList.remove("active");
    // Deactivate it's content
    if (content.classList.contains("active")) {
        content.setAttribute("aria-hidden", true);
        content.classList.remove("active");
    }
}
/**
 * Return the index of parent's content
 *
 * @param {Object} parent
 * @return {Object|null} Parent's content index or null
 */
function getParentContentIndex(parent) {
    var className = 'content';
    // Stop if parent is not actually an element
    if (!parent || parent.length === 0) {
        return null;
    }
    do {
        if (parent === document) {
            break;
        }
        if (parent.classList.contains(className)) {
            // Get the parent's tabindex attribute
            var parentIndex = parent.getAttribute('tabindex');
            // Return it as a number
            return parseInt(parentIndex);
        }
        parent = parent.parentNode;
    } while (parent);
    // Return null if nothing found
    return null;
}
/**
 * Set child tab index in title element of tabObjMaps
 *
 * @param {int} parentIndex
 * @param {int} index
 * @return {null}
 */
function setChildTabIndex(parentIndex, index) {
    if (null !== parentIndex && tabObjMaps.length !== 0) {
        tabObjMaps[parentIndex]["childTabIndex"] = index;
    }
    return null;
}
/**
 * Returns specific title node
 *
 * @param {int} tabIndex
 * @param {int} titleIndex
 * @return {Object} Title
 */
function getTitle(tabIndex, titleIndex) {
    return window.tabs[tabIndex].querySelector('.tab-title[tabindex="' + titleIndex + '"], .active.accordion-navigation[tabindex="' + titleIndex + '"');
}
/**1
 * Returns tabs the first title node
 *
 * @param {int} tabIndex
 * @return {Object} Title
 */
function getFirstTitle(tabIndex) {
    return window.tabs[tabIndex].querySelector('.tab-title, .active.accordion-navigation');
}
/**
 * Returns the title index
 *
 * @param {Object} title
 * @return {int} Title index
 */
function getTitleIndex(title) {
    return title.getAttribute('tabindex');
}
/**
 * Returns the specific tab's active title node
 *
 * @param {int} tabIndex
 * @return {(Object|null)} Active title
 */
function getActiveTitle(tabIndex) {
    var activeTitle = window.tabs[tabIndex].querySelector('.tab-title.active, .active.accordion-navigation');
    return (activeTitle) ? activeTitle : null;
}
/**
 * Returns the title's content
 *
 * @param {Object} title
 * @return {Object} Content
 */
function getContentByTitle(title) {
    var tabIndex = getTitleIndex(title);
    var content = document.querySelector('.tabs ~ .tabs-content .content[tabindex="' + tabIndex + '"], .accordion .content[tabindex="' + tabIndex + '"]');
    // After resize event, the tabs content class will change and else block will be execute
    if (content) {
        return content;
    }
    else {
        return document.querySelector('.tabs ~ .tabs-content .tabs-panel[tabindex="' + tabIndex + '"], .accordion .content[tabindex="' + tabIndex + '"]');
    }
}
/**
 * Changes hash in URL
 *
 * @param {string} newHash
 */
function setHref(newHash) {
    if (history.pushState) {
        history.replaceState(null, null, newHash);
    }
    else {
        location.hash = newHash;
    }
}
/**
 * This functon is a polyfill for node.querySelectorAll(':scope > selector')
 * Reason: IE browser doesn't support the :scope selector
 *
 * @param {Object} node
 * @param {string} selector
 * @return {Object}
 */
function findAll(node, selector) {
    var removeUniqueData = false;
    var result = [];
    // Adding an UUID to the element
    if (node.getAttribute('data-helper-scope-uuid') === null) {
        // Generating an UUID
        var UUID = 'uuid-' + Date.now() + '';
        // Setting it as attribute
        node.setAttribute('data-helper-scope-uuid', UUID);
        removeUniqueData = true;
        // Query the elements of the element with the UUID
        result = document.querySelectorAll('[data-helper-scope-uuid="' + UUID + '"]  > ' + selector);
    }
    // Removing the UUID after we found the desired elements
    if (removeUniqueData) {
        node.removeAttribute('data-helper-scope-uuid');
    }
    return result;
}
